<template>
    <div class="RPFilter">
        <RPDropdownButton
            ref="button"
            :dropdown-position="dropdownPosition"
            :type="type"
            :disabled="disabled"
            :default-label="defaultLabel"
            :default-icon="defaultIcon"
            :default-icon-size="defaultIconSize"
            :default-icon-color="defaultIconColor"
            :hide-arrow="hideArrow"
            :show-dropdown="size > 657"
            @button-state="setButtonState"
        >
            <template v-slot:default>
                <slot></slot>
            </template>
            <template
                v-if="size > 657"
                v-slot:dropdown
            >
                <slot
                    name="dropdown"
                    :isModal="false"
                ></slot>
            </template>
        </RPDropdownButton>
        <RPModal
            v-if="size <= 657 && buttonState"
            :show-action-buttons="false"
            header="Reviews Filter"
            @close-modal="close"
        >
            <template slot="modalBody">
                <slot
                    name="dropdown"
                    :isModal="true"
                ></slot>
            </template>
        </RPModal>
    </div>
</template>
<script>
import RPDropdownButton from 'components/Basic/Buttons/DropdownButton/RPDropdownButton.vue';
import RPModal from 'components/Complex/Modal/RPModal.vue';
import colors from 'style/_colors.scss';
export default {
    name: 'RPFilter',
    components: {
        RPDropdownButton,
        RPModal
    },
    props: {
        type: {
            type: String,
            default: 'primary',
            validator: val => ['primary', 'secondary', 'tertiary'].indexOf(val) !== -1,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        defaultLabel: {
            type: String,
            default: 'Select',
        },
        defaultIcon: {
            type: [Object, Array],
            default: () => ({}),
        },
        defaultIconSize: {
            type: Number,
            default: 16,
        },
        defaultIconColor: {
            type: String,
            default: colors.grey600,
        },
        hideArrow: {
            type: Boolean,
            default: false,
        },
        dropdownPosition: {
            type: String,
            default: 'right',
            validator: val => ['left', 'right', 'center'].indexOf(val) !== -1
        },
    },
    data(){
        return {
            size: 'large',
            buttonState: false
        };
    },
    mounted() {
        this.size = window.innerWidth;
        window.addEventListener('resize', () => {
            this.size = window.innerWidth;
        });
    },
    methods: {
        setButtonState(bool){
            this.buttonState = bool;
        },
        close(){
            this.$refs.button.close();
        }
    }
};
</script>
<style lang="scss">
.RPFilter {
}
</style>
